'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _tslib = require('../../_virtual/_tslib.js');
var jsxRuntime = require('react/jsx-runtime');
var React = require('react');

var SvgAlertCircleFill = function (props, ref) { return (jsxRuntime.jsx("svg", _tslib.__assign({ xmlns: "http://www.w3.org/2000/svg", fill: "currentColor", viewBox: "0 0 24 24", ref: ref }, props, { children: jsxRuntime.jsx("path", { fillRule: "evenodd", d: "M24 12c0 6.6274-5.3726 12-12 12-6.62742 0-12-5.3726-12-12C0 5.37258 5.37258 0 12 0c6.6274 0 12 5.37258 12 12ZM12 6c-.3834.00022-.7488.16254-1.006.44687-.2572.28433-.3821.66414-.344 1.04563l.525 5.2605c.0366.4284.395.7576.825.7576.43 0 .7884-.3292.825-.7576l.525-5.2605c.0381-.38149-.0868-.7613-.344-1.04563C12.7488 6.16254 12.3834 6.00022 12 6Zm.003 9c-.8284 0-1.5.6716-1.5 1.5s.6716 1.5 1.5 1.5 1.5-.6716 1.5-1.5-.6716-1.5-1.5-1.5Z", clipRule: "evenodd" }) }))); };
var ForwardRef = React.forwardRef(SvgAlertCircleFill);

exports["default"] = ForwardRef;
//# sourceMappingURL=AlertCircleFill.js.map
